import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from 'types';

export const initialState: AppState = {
  loading: false,
  manufactures: [],
  distributors: [],
  territory: [],
  representatives:[],
  groups:[],
  teams:[],
  roles: []
};

const slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setManufactures: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.manufactures = payload || [];
    },
    setDistributors: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.distributors = payload || [];
    },
    setRepresentative: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.representatives = payload || [];
    },
    setGroups: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.groups = payload || [];
    },
    setTeams: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.teams = payload || [];
    },
    setTerritory: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.territory = payload || [];
    },
    setRoles: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.roles = payload || [];
    }
  }
});

export const { setManufactures, setDistributors, setRepresentative, setGroups, setTeams, setTerritory, setRoles } =
  slice.actions;

export default slice.reducer;
